var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 6.99992C13.6666 10.6818 10.6818 13.6666 6.99992 13.6666C3.31802 13.6666 0.333252 10.6818 0.333252 6.99992C0.333252 3.31802 3.31802 0.333252 6.99992 0.333252C10.6818 0.333252 13.6666 3.31802 13.6666 6.99992Z",
    fill: "#2A3040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99992 3.83325C7.27606 3.83325 7.49992 4.05711 7.49992 4.33325V6.79281L9.02014 8.31303C9.2154 8.50829 9.2154 8.82488 9.02014 9.02014C8.82488 9.2154 8.50829 9.2154 8.31303 9.02014L6.64637 7.35347C6.5526 7.2597 6.49992 7.13253 6.49992 6.99992V4.33325C6.49992 4.05711 6.72378 3.83325 6.99992 3.83325Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.7c239de6f71cf9bf3c805bab990e94e7.svg";
export { ForwardRef as ReactComponent };